export const slotGamesTextContent = {
  headingText: "Slot Games",
  paraText:
    "GammaSlots offer a massive range of slot games tailored for your needs. From ideation to deployment, we offer custom games with highly innovative features that deliver immersive slot experiences.",
  btnText: "View All",
  slotGamesContent: [
    {
      gameImageSrc: "/assets/stock-img/slot_game_img_01.webp",
      gameNameText: "Jungle Rave",
    },
    {
      gameImageSrc: "/assets/stock-img/slot_game_img_02.webp",
      gameNameText: "Feral Quest",
    },
    {
      gameImageSrc: "/assets/stock-img/slot_game_img_03.webp",
      gameNameText: "Santa Downfall",
    },
    {
      gameImageSrc: "/assets/stock-img/slot_game_img_04.webp",
      gameNameText: "Jewels of Wizard",
    },
  ],
};
